export const BREAKPOINTS = {
  xxs: '452px',
  xs: '512px',
  sm: '720px',
  md: '768px',
  lg: '1000px',
  xl: '1320px',
  '2xl': '1680px',
}
